module.exports = __webpack_public_path__ + "img/70.4e62a68e.jpg";